import { FaRedo } from "react-icons/fa";

export default function ProfileTabLoadMore({
  sentinelRef,
  loadingMore,
  hasNextPage,
  onLoadMore,
  itemCount,
  endMessage = "You've reached the end",
  compact = false,
}) {
  if (compact) {
    if (loadingMore) {
      return <p className="app-right-sidebar-hint sidebar-section-load-more">Loading more…</p>;
    }
    if (hasNextPage) {
      return (
        <div ref={sentinelRef} className="sidebar-section-load-more">
          <button
            type="button"
            onClick={onLoadMore}
            className="app-right-sidebar-inline-link"
          >
            Load more
          </button>
        </div>
      );
    }
    return null;
  }

  if (loadingMore) {
    return (
      <div className="group-page__feed-loading group-page__feed-loading--more">
        <div className="group-page__feed-spinner" />
        <p>Loading more…</p>
      </div>
    );
  }

  if (hasNextPage) {
    return (
      <div ref={sentinelRef} className="group-page__load-more-wrap">
        <button
          type="button"
          onClick={onLoadMore}
          className="group-page__load-more"
        >
          <FaRedo aria-hidden="true" />
          Load more
        </button>
      </div>
    );
  }

  if (itemCount > 0) {
    return <p className="group-page__feed-end">{endMessage}</p>;
  }

  return null;
}
